import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Singleselect from '../../component//singleselect.vue'
import MultiSelect from '../../component/multiselect.vue'

if ($('#size_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#size_form',
    components: {
      RingLoader,
      TextInput,
      NumberInput,
      Singleselect,
      MultiSelect,
    },
    mixins: [mixins],
    data: {
      loading: 0,
      form: {
        entity: {},
        options: {
          errors: {},
          mealTypes: [],
          brands: [],
        }
      },
      entityId: null,
    },
    mounted() {
      this.loading++

      if ($('#entity_id').length) {
        this.entityId = $('#entity_id').val()
        this.getSize().then(() => {
          this.getBrands()
          this.getMealTypes()
          this.loading--
        })
      } else {
        this.getBrands()
        this.getMealTypes()
        this.loading--
      }
    },
    methods: {
      createSize(redirect) {
        let url = Routing.generate('api_post_size')

        let data = { data: this.form.entity }
        this.loading++

        this.$http.post(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('size_grid'))
          } else {
            toastr.success(Translator.trans('size.form.created'))
            this.form.options.errors = {}
          }
          this.loading--

        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      updateSize(redirect) {
        this.loading++

        let url = Routing.generate('api_patch_size', {
          id: this.entityId,
        })

        let data = { data: this.form.entity }

        this.$http.patch(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('size_grid'))
          } else {
            toastr.success(Translator.trans('size.form.updated'))
            this.form.options.errors = {}
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      getSize() {
        this.loading++

        return this.$http.get(Routing.generate('api_get_size', {
          id: this.entityId,
          context: 'edit'
        })).then(response => {
          const data = response.data
          data.brands = data.brands.map(brand => brand.id)
          data.mealType = data.mealType ? data.mealType.id : null

          this.form.entity = data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getBrands() {
        this.loading++

        this.$http.get(Routing.generate('api_get_brands', { context: 'dropdown' }))
          .then(response => {
            this.form.options.brands = response.data
            this.loading--
          }, response => {
            this.loading--
            this.handleAjaxError(response)
          })
      },
      getMealTypes() {
        this.loading++

        this.$http.get(Routing.generate('api_get_meal_types', { context: 'dropdown' }))
          .then(response => {
            this.form.options.mealTypes = response.data
            this.loading--
          }, response => {
            this.handleAjaxError(response)
            this.loading--
          })
      },
    }
  })
}
